import axios from 'axios';

import type { GetApiV1RewardsResponse } from '~/api/generated';
import type { PageData } from '~/common/Pagination';

export type Reward = GetApiV1RewardsResponse['records'][number];

export interface PagedRewards {
  records: Reward[];
  pageData: PageData;
}

export async function fetchRewards(page: number): Promise<PagedRewards> {
  const { data } = await axios.get<GetApiV1RewardsResponse>(
    '/api/v1/rewards',
    { params: { page } },
  );

  return {
    records: data.records,
    pageData: {
      perPage: data.metadata.per_page,
      totalRows: data.metadata.total_count,
    },
  };
}
